import { render, staticRenderFns } from "./SetClock.vue?vue&type=template&id=cfeb4344"
import script from "./SetClock.vue?vue&type=script&lang=js"
export * from "./SetClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports